import * as yup from 'yup'

export const attendanceBulkSettingSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    working_rate: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === '' || originalValue === null ? undefined : value
      })
      .typeError(__('Working Rate must be a number'))
      .min(0)
      .max(100)
      .notRequired()
  })
}
